// extracted by mini-css-extract-plugin
export var inputWrapper = "InputCopy_inputWrapper__c2jNU";
export var inputCopy = "InputCopy_inputCopy__b1+vQ";
export var copied = "InputCopy_copied__7aOAW";
export var rotate = "InputCopy_rotate__0ETp5";
export var dotty = "InputCopy_dotty__ENZ3j";